"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rspCompTableToken = void 0;
var tokens_1 = require("../../../../tokens");
var token_adapter_1 = require("../../../token-adapter");
exports.rspCompTableToken = (0, token_adapter_1.flattenToken)(tokens_1.compTokens.tables);
//# sourceMappingURL=table.js.map